import React from "react";

import { Switch } from "@/components/ui/switch";

/**
 * Toggle — Schalter mit Beschriftung.
 *
 * Hülle um `<Switch>`; `onChange` liefert wie beim Primitive einen Boolean.
 */
const Toggle = ({ label, checked, onChange, disabled }) => (
  <label className="flex items-center gap-[1rem] cursor-pointer my-[0.6rem]">
    <Switch checked={!!checked} onChange={onChange} disabled={disabled} />
    {label && (
      <span className="text-[1.3rem] text-foreground break-words">{label}</span>
    )}
  </label>
);

export default Toggle;
